import { Component, OnInit } from '@angular/core';
import { HelperService } from '../../core/services/helper.service';
import { ShoppingService } from '../../core/services/shopping.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.css']
})
export class PromptComponent implements OnInit {

  BackToPageUrl: string;
  constructor(private helperService: HelperService, private shoppingService: ShoppingService,
    private dialogRef: MatDialogRef<PromptComponent>) { }

  ngOnInit() {
    this.shoppingService.observeBackToPageUrl.subscribe(appurl => {
      this.BackToPageUrl = appurl;
    });
  }
  OnClose() {
    this.shoppingService.IsPromptShown = false;
    this.dialogRef.close('');
  }
  OnContinueShopping() {
    this.shoppingService.IsPromptShown = false;
    this.helperService.backToSite(this.BackToPageUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/prompt/prompt.component.ts